// extracted by mini-css-extract-plugin
export var colorize = "taglet-module--colorize--54bdf";
export var selected = "taglet-module--selected--91f60";
export var taglet = "taglet-module--taglet--b863c";